import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';

import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import {HylyCheckbox} from './icons';

import Input from './SelectInput';
import Icon from '../Icon';
import { DropDownIconComponent } from './icons';

import styles, {analyzeTemplate, select_class_for_menu} from './common_styles';

import MenuProps from './menuProps';

const {
  menuItem
  , selected
  , box_root
  , listItemText
  , rootOpen
  , root
  , select
  , formControl
  , formControl_with_border
  , colorSecondary
  , checked
  , disabled
  , setBold
} = styles;


export const ListItem = React.memo(
    withStyles(theme => ({
      menuItem: {
        // padding:`${theme.spacing_unit.md/2}px ${theme.margins.xs}px`,
        padding: '8px 16px',
        '&:hover:not($disabled):not($selected)':{
          background: '#f5f5f5'//theme.palette.hoverColor
        }
      },
      box_root: {
        fontSize: '5px !important',
        margin:`0 16px 0 0`,
        padding:'0'
      },
      listItemText: {
        textOverflow: 'ellipsis',
        overflow:'hidden',
        whiteSpace: 'nowrap',
        //padding:`0 ${theme.margins.xs}px`,
        [theme.breakpoints.up('sm')]: {
          //padding:`0 ${theme.margins.sm}px`,
        }
      },
      selected: {},
      checked: {},
      disabled:{},
      focused: {},
    }))
    (({ id, name, classes, selected_value, onCheck, ...props }) => {

      const checked = React.useMemo(
        () => {
          if (props.checked !== undefined && props.checked !== null) {
            return props.checked;
          }

          return typeof selected_value === 'string'
            ? selected_value.indexOf(name) > -1
            : selected_value.find(o => {
              if (o === name) { return true; }
              if (o.id && o.id === id) { return true }
              if (!o.id && o.name && o.name === name) { return true; }
              return false;
            })
        },[selected_value, name, props.checked]
      )

      const onClick = React.useCallback((e) => props.onClick
        ? props.onClick(e)
        : onCheck && onCheck(name)
      );

      return (
        <MenuItem
          {...props}
          value   ={name}
          classes = {{ root: classes.menuItem, selected: classes.selected }}
          onClick = {onClick}
        >
          <HylyCheckbox
              checked    = {!!checked}
              className  = {classes.box_root}
          />
          <ListItemText primary={name} classes = {{ root: classes.listItemText }}/>
        </MenuItem>
      )
    }
  )
);

export const ListValues = React.memo(
  ({ values, selected_value, onCheck }) => {
    return (<>
    {
      values.map(
        (name, id) =>
          <ListItem
            key = {`ListItem-${name}-${id}`}
            name = {name}
            selected_value = {selected_value}
          />
      )
    }
  </>
  );
})

export const CheckboxInput = React.memo(
  withStyles(theme => ({
    rootOpen: {
      background: theme.palette.hoverColor,
      color: theme.darkBlack,
      fontWeight: 600,
    }
  }))
  (({
    im_hovered_upon
    , drop_down_menu_button
    , classes
    , input_class
    , icon_adornment_size
    , icon_component
    , select_disabled
    , ...props
  }) => {
    return <Input
      {...props}
      id="select-multiple-checkbox"
      className = {(im_hovered_upon && !drop_down_menu_button) ? classes.rootOpen : ''}
      input_class = {input_class}
      iconComponent = {
        Boolean(icon_component)
        ? <Icon
            size = {icon_adornment_size}
            type = {icon_component}
            disabled = {select_disabled}
          />
        : null
      }
    />
  }
 )
)

const CheckboxField = ({
    classes
    , selected_value
    , values
    , handleChange
    , name
    , open
    , handleOpen
    , handleClose
    , selected_field
    , icon_component
    , icon_adornment_size
    , select_disabled
    , im_hovered_upon
    , onMouseEnter
    , onMouseLeave
    , dropdown_icon
    , dropdown_tooltip_text
    , input_class
    , full_width_xs
    , type
    , drop_down_menu_button
    , menuProps: menuProps_
  }) => {

    const paper_class = React.useMemo(
      () => select_class_for_menu({
        direction: type === "icon" ? "right" : "left"
        , fullWidth: full_width_xs
        , classes
        , no_adornment: !Boolean(icon_component)
      })
    ,[ type ,full_width_xs, icon_component ])

    const menuProps = React.useMemo(() =>
      MenuProps(
        Object.assign(
          { paper_class, direction: type === "icon" ? "right" : "left" }
          ,menuProps_
        )
      )
    ,[menuProps_, type, paper_class ])

    const renderValue = React.useCallback(selected => analyzeTemplate(selected_field, selected.length), [selected_field]);

    const dropDownComponentProps = React.useMemo(() => (
      {
        size: type === "icon" ? "md" : "sm",
        select_disabled: select_disabled,
        dropdown_icon: dropdown_icon,
        dropdown_tooltip_text: dropdown_tooltip_text,
        is_button: drop_down_menu_button
      }
    ),[type, select_disabled, dropdown_icon, dropdown_tooltip_text, drop_down_menu_button])

    return (
      <Select
            multiple
            value={selected_value}
            onChange={handleChange}
            open = {open}
            onClose = {handleClose}
            onOpen = {handleOpen}
            disabled = {select_disabled}
            onMouseEnter = {onMouseEnter}
            onMouseLeave = {onMouseLeave}
            input = {
              <CheckboxInput
                  input_class = {input_class}
                  icon_component = {icon_component}
                  icon_adornment_size = {icon_adornment_size}
                  select_disabled = {select_disabled}
                  im_hovered_upon = {im_hovered_upon}
                  drop_down_menu_button = {drop_down_menu_button}
              />
            }
            IconComponent = {() => <DropDownIconComponent {...dropDownComponentProps} />}
            renderValue={renderValue}
            name = {name}
            MenuProps = {menuProps}
            classes = {{
              root: classes.root,
              select: classes.select
            }}
            onClick = {e => handleOpen(e, select_disabled)}
          >
          {values.map(name => (
              <MenuItem
                key={name}
                value={name}
                classes = {{
                  root: menuItem,
                  selected
                }}
              >
                <HylyCheckbox
                    checked={selected_value.indexOf(name) > -1}
                    className = {box_root}
                />
                <ListItemText primary={name} classes = {{root: listItemText}}/>
              </MenuItem>
             ))
           }
      </Select>
    )
  };


CheckboxField.propTypes = {
  classes: PropTypes.shape({
    formControl: PropTypes.string.isRequired,
    formControl_with_border: PropTypes.string.isRequired,
    colorSecondary: PropTypes.string.isRequired,
    checked: PropTypes.string.isRequired,
    disabled: PropTypes.string.isRequired,
    select: PropTypes.string.isRequired,
    setBold: PropTypes.string.isRequired,
    root: PropTypes.string.isRequired,
    rootOpen: PropTypes.string.isRequired,
    selected: PropTypes.string.isRequired
  }),
  checkbox_format:PropTypes.string,//PropTypes.func,
  selected_value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]).isRequired,
  values: PropTypes.array.isRequired,
  handleChange: PropTypes.func,
  name: PropTypes.string,
  open: PropTypes.bool,
  handleOpen: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  icon_component: PropTypes.string,
  icon_adornment_size: PropTypes.oneOf(['xs','sm','md','lg','xl']),
  select_disabled: PropTypes.bool,
  im_hovered_upon: PropTypes.bool,
  onMouseEnter:PropTypes.func.isRequired,
  onMouseLeave:PropTypes.func.isRequired,
  dropdown_icon: PropTypes.string,
  input_class: PropTypes.string,
  full_width_xs: PropTypes.bool
}

CheckboxField.defaultProps = {
  values: [],
  selected_value:'',
  icon_adornment_size: 'md',
  selected_field: 'selected value/s',//num => `${num} Propert${num > 1 ? 'ies':'y'}`,
  dropdown_icon: "icon-down-arrow"
}

export default React.memo(withStyles(styles)(CheckboxField));
